<template>
  <div class="CARD">
    <div
        v-tooltip="{
          content: service.name
        }"
        class="SERVICE">{{ service.name }}</div>
    <div class="PRICE-UNIT">
      <span v-if="showDollar" class="DOLLAR">$</span>
      <span :class="longPrice ? 'PRICE-LONG as-center' : 'PRICE as-center'">{{price}}</span>
      <span class="UNIT " v-if="service.unit">/{{service.unit}}</span>
    </div>
  </div>
</template>
<script>
import { PRICING_OPTIONS } from '@/constants/pricing-options';

export default {
  PRICING_OPTIONS,
  name: 'service-card',

  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  computed: {
    longPrice () {
      return (this.price || '').length > 7;
    },
    price () {
      switch (this.service.unit) {
        case this.$options.PRICING_OPTIONS.range.value:
          return `${this.service.minimum_price}-${this.service.maximum_price}`;
        case this.$options.PRICING_OPTIONS.hourly.value:
        case this.$options.PRICING_OPTIONS.estimate.value:
          return `${this.service.maximum_price}`;
        default:
          return this.$options.PRICING_OPTIONS.contact.label;
      }
    },
    showDollar () {
      return this.price !== this.$options.PRICING_OPTIONS.contact.label;
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .SERVICE {
    white-space: nowrap;
    overflow: hidden;
    text-overflow:ellipsis;
    margin-left: 10px;
    margin-top: 10px;
    //padding: 8px;
    font-weight: 400;
    font-size: 11px;
    color: #606060;
  }

  // .price-unit-row {
  //   display: flex;
  //   align-items: flex-end;
  //   flex-wrap: wrap;
  //   gap: 2px;
  //   margin-left: 10px;
  //   margin-top: 0px;
  //   //position: absolute;
  // }
  .PRICE {
    font-size: 16px;
    font-weight: 700;
    position: static;
    margin-right: 2px;
  }
  .PRICE-LONG {
    font-size: 16px;
    font-weight: 700;
    position: static;
    margin-right: 2px;
  }
  .DOLLAR {
    font-size: 16px;
    font-weight: 700;
    position: static;
    margin-right: 2px;
  }
  .UNIT {
    font-size: 11px;
    font-weight: 400;
    color: #606060;
    margin-left: 0px;
    position: static;
    white-space: nowrap;
  }

  .PRICE-UNIT {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 2px;
    margin-left: 10px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0px;
  }

  .CARD {
    //padding: 8px 4px;
    position: relative;
    display: flex;
    flex-direction: column;
    text-align: left;
    width: 191px;
    height: 80px;
    margin: 0;
    border: solid #D9D9D9 1px;
    border-radius: 5px;
    @include mobile-only() {
      width: 90%;
    }
  }

</style>
